// @flow
import React from 'react';
import { convertToRaw } from 'draft-js';
import { createEditorState } from 'medium-draft';
import mediumDraftImporter from 'medium-draft/lib/importer';
import mediumDraftExporter from 'medium-draft/lib/exporter';
import { createFragmentContainer, graphql } from 'react-relay';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
// material-ui
import TextField from 'material-ui/TextField';
import IconButton from 'material-ui/IconButton';
import Paper from 'material-ui/Paper';
import SelectField from 'material-ui/SelectField';
import Divider from 'material-ui/Divider';
import DatePicker from 'material-ui/DatePicker';
import TimePicker from 'material-ui/TimePicker';
import MenuItem from 'material-ui/MenuItem';

// icon
import ActionSchedule from 'material-ui/svg-icons/action/schedule';
import ActionEvent from 'material-ui/svg-icons/action/event';
import ImagePhoto from 'material-ui/svg-icons/image/photo';
import DraftEditor from '../editor/draft/DraftEditor';
import Toggle from 'material-ui/Toggle';

import { preserveDate } from '../../lib/DateUtils';
import * as EpisodeEditMutation from '../../mutations/TVShowEpisodeEditMutation';
import * as EpisodeAddMutation from '../../mutations/TVShowEpisodeAddMutation';
// components
import TopicSelector from '../TopicSelector';
import Preview from '../preview/Preview';
import { DefaultButton } from '../controls/button';
import Icon from '../ui/icon/icon';
//
import updateMediaFile from '../media/updateMediaFile';
// Gallery
import PopupGallery from '../media/PopupGallery';
// style
import '../ui/form.css';
import '../ui/date-column.css';
import dateTimeStyle from '../ui/date-time-style';
import buttonStyle from '../ui/button';
import { styles, formElement, colors, paperStyle } from '../../lib/styles';
import Subheader from "material-ui/Subheader";

require('moment/locale/ru');

moment.locale('ru');

type Props = {
    epgitem: Object,
    history: Object,
    relay: Object,
    viewer: Object,
}

type State = {
    description: string,
	editorState: ?Function,
    endDate: Date,
    openGallery: boolean,
    galleryType: Array<string>,
    shortDescription: ?string,
    show: ?string,
    startDate: Date,
    state: string,
    subtitle: string,
    suggestions: Array<{id: string, title: string}>,
    title: ?string,
    topics: Array<?{id: string, name: string}>,
    video: ?string,
    videoFile: ?string,
    preview: ?string,
    previewUrl: ?string,
    isPreview: boolean,
}

const setTitle = (edges, showId) => {
    let name = '';
    edges.map((edge) => {
        if (edge.node.id === showId) {
            name = edge.node.title;
            return name;
        }
        return '';
    });
    return name;
};

/**
 * Установка даты, на тот случай, если передача началась в один день, а закончилась в другой
 * @param {String} dateStart дата и время начала
 * @param {String} dateEnd дата и время окончания
 * @returns {Date}
 */
const checkDate = (dateStart: Date, dateEnd: Date) => {
    const dateStartFormat = new Date(dateStart);
    let dateEndFormat = new Date(dateEnd);
    // Приводим к одному дню, на случай, если сменилась дата
    dateEndFormat = new Date(dateEndFormat.setFullYear(dateStartFormat.getFullYear()));
    dateEndFormat = new Date(dateEndFormat.setMonth(dateStartFormat.getMonth()));
    dateEndFormat = new Date(dateEndFormat.setDate(dateStartFormat.getDate()));

    if (dateStartFormat > dateEndFormat) {
        const tD = new Date(dateEndFormat.setDate(dateEndFormat.getDate() + 1));
        return new Date(tD.toISOString());
    }
    return new Date(dateEndFormat.toISOString());
};

const getParentId = (episode?: Object) => {
    if (episode) {
        return episode.show ? episode.show.id : null;
    }
    return window.location.search.replace('?parent=', '');
};

class EpgItem extends React.Component<Props, State> {
    constructor(props) {
        super(props);

        const episode = props.epgitem;
        const isEpisode = episode !== null;

        const show = getParentId(episode);
        const title = isEpisode ? episode.title : setTitle(this.props.viewer.tvshows.edges, show);
        let videoUrl = isEpisode && episode.videoFile ? episode.videoFile.filename : '';
        if (!videoUrl) {
            videoUrl = isEpisode && episode.video ? episode.video : '';
        }

		const editorState = createEditorState(convertToRaw(mediumDraftImporter(episode.description)));
		
        this.state = {
            endDate: isEpisode ? new Date(episode.endDate) : new Date(),
            startDate: isEpisode ? new Date(episode.startDate) : new Date(),
            title,
            subtitle: isEpisode ? episode.subtitle : ' ',
            description: isEpisode ? episode.description : ' ',
			liveShow: isEpisode ? episode.liveShow: false,
			surdo: isEpisode ? episode.surdo: false,
            shortDescription: isEpisode && episode.shortDescription ? episode.shortDescription : ' ',
            show,
            suggestions: this.props.viewer.tvshows !== null ?
                this.props.viewer.tvshows.edges.map(edge => edge.node) :
                [],
            topics: isEpisode ? episode.topics : [],
            video: videoUrl,
            videoFile: isEpisode && episode.videoFile ? episode.videoFile.id : '',
            preview: isEpisode && episode.preview ? episode.preview.id : '',
            isPreview: false,
            previewUrl: isEpisode && episode.preview ? episode.preview.filename : '',
            state: isEpisode && episode.state ? episode.state : 'available',
            openGallery: false,
			editorState,
            galleryType: ['video'],
        };
    }

    openDatePicker = (el) => {
        this.refs[el].openDialog();
    };

    save = () => {
        const baseParams = {
            title: this.state.title,
            videoFile: this.state.videoFile,
            preview: this.state.preview,
            show: this.state.show,
			liveShow: this.state.liveShow,
			surdo: this.state.surdo,
            topics: this.state.topics.map(t => t.id),
            description: this.state.description,
            shortDescription: this.state.shortDescription,
            startDate: this.state.startDate.toISOString(),
            endDate: checkDate(this.state.startDate, this.state.endDate).toISOString(),
            subtitle: this.state.subtitle,
            state: this.state.state,
        };
        const episode = this.props.epgitem;

        const callback = (error: ?Error, showId: ?string) => {
            if (error !== null) {
                alert('error saving show');
                console.log(error);
                return;
            }

            if (showId) {
                this.props.history.replace(`/epg/${showId}`);
            }
        };
        if (baseParams.videoFile.length) {
            const updateDataForMediaFile = {
                title: `${baseParams.title}, Выпуск ${moment(this.state.startDate).format('L')}`,
                description: baseParams.description,
                topics: this.state.topics,
            };
            updateMediaFile(baseParams.videoFile, updateDataForMediaFile);
        }

        if (episode !== null) {
            const params = {
                id: episode.id,
                ...baseParams,
            };
            EpisodeEditMutation.commit(this.props.relay.environment, params, callback);
        } else {
            EpisodeAddMutation.commit(this.props.relay.environment, baseParams, callback);
        }
    };

    insertMedia = (item) => {
        if (this.state.isPreview) {
            this.setState({
                preview: item.id,
                previewUrl: item.filename,
            });
        } else {
            this.setState({
                video: item.filename,
                videoFile: item.id,
            });
        }
        this.setState({
            openGallery: false,
            isPreview: false,
        });
    };

    render() {
		const { editorState } = this.state;

        const timePickerStyle = {
            width: '100px',
        };

        return (
            <div style={styles.twinPanes.wrapper}>
                <Paper style={paperStyle.mainItem}>
                    <TextField
                        style={formElement.textField}
                        floatingLabelStyle={formElement.label}
                        inputStyle={formElement.textFieldInput}
                        value={this.state.title}
                        fullWidth
                        floatingLabelText="Название"
                        onChange={(e, v) => this.setState({ title: v })}
                    />

					<TextField
						style={formElement.textField}
						floatingLabelStyle={formElement.label}
						inputStyle={formElement.textFieldInput}
						value={this.state.subtitle}
						fullWidth
						floatingLabelText="Подзаголовок"
						onChange={(e, v) => this.setState({ subtitle: v })}
					/>

                    <TextField
                        style={formElement.textField}
                        floatingLabelStyle={formElement.label}
                        inputStyle={formElement.textFieldInput}
                        value={this.state.shortDescription}
                        fullWidth
                        floatingLabelText="Короткое описание"
                        multiLine
                        rows={1}
                        rowsMax={4}
                        onChange={(e, v) => this.setState({ shortDescription: v })}
                    />

					<label style={{
						color: 'rgb(119, 119, 119)',
						fontSize: 12,
						transform: 'scale(0.75)'
					}}>Полное описание</label>
					<div className="md-RichEditor-wrapper">
						<DraftEditor
							state={editorState}
							location={null}
							onChange={editorState => {
								const description = mediumDraftExporter(editorState.getCurrentContent());
								this.setState({
									editorState,
									description
								})
							}}
						/>
					</div>

					<Divider />

                    <div
                        style={{
                            marginTop: 11,
                            marginBottom: 8,
                        }}
                    >
                        <small style={formElement.smallTitle}>Обложка</small>
                        {this.state.preview && <Preview
                            item={this.state.previewUrl}
                            mediaId={this.state.preview}
                            removePreview={() => {
                                this.setState({
                                    preview: '',
                                    previewUrl: '',
                                });
                            }}
                        />
                        }
                        <Icon icon="plus" />
                        <IconButton
                            containerElement="label"
                            style={buttonStyle.icon_space}
                            className="btn__hover_empty"
                            onClick={() => (this.setState({
                                openGallery: true,
                                isPreview: true,
                                galleryType: ['image'],
                            }))}
                        >
                            <ImagePhoto color={colors.link} />
                        </IconButton>
                    </div>
                    <Divider style={formElement.divider} />

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            marginTop: 22,
                        }}
                    >
                        <div className="date-column__long">
                            <DatePicker
                                textFieldStyle={dateTimeStyle.datePicker}
                                floatingLabelStyle={formElement.label}
                                underlineStyle={formElement.underLineStyle}
                                autoOk
                                ref="dp"
                                className="date-field"
                                floatingLabelText="Дата выхода"
                                value={this.state.startDate}
                                formatDate={date => moment(date).format('DD MMMM YYYY')}
                                onChange={(e, d) => this.setState({
                                    startDate: preserveDate(this.state.startDate, d),
                                })}
                            />
                            <IconButton
                                style={buttonStyle.icon}
                                onClick={() => this.openDatePicker('dp')}
                            >
                                <ActionEvent color={colors.link} />
                            </IconButton>
                        </div>
                        <div className="date-column__short">
                            <TimePicker
                                textFieldStyle={dateTimeStyle.timePickerField}
                                floatingLabelStyle={dateTimeStyle.timePickerLabel}
                                inputStyle={dateTimeStyle.timePickerInput}
                                underlineStyle={formElement.underLineStyle}
                                ref="dpts"
                                autoOk
                                format="24hr"
                                floatingLabelText="с"
                                value={this.state.startDate}
                                onChange={(e, d) => this.setState({
                                    startDate: preserveDate(this.state.startDate, d),
                                })}
                                style={timePickerStyle}
                            />
                            <IconButton
                                style={buttonStyle.icon}
                                onClick={() => this.openDatePicker('dpts')}
                            >
                                <ActionSchedule color={colors.link} />
                            </IconButton>
                        </div>
                        <div className="date-column__short">
                            <TimePicker
                                textFieldStyle={dateTimeStyle.timePickerField}
                                floatingLabelStyle={dateTimeStyle.timePickerLabel}
                                inputStyle={dateTimeStyle.timePickerInput}
                                underlineStyle={formElement.underLineStyle}
                                ref="dpte"
                                autoOk
                                format="24hr"
                                floatingLabelText="по"
                                value={this.state.endDate}
                                onChange={(e, d) => this.setState({
                                    endDate: preserveDate(this.state.endDate, d),
                                })}
                                style={timePickerStyle}
                            />
                            <IconButton
                                style={buttonStyle.icon}
                                onClick={() => this.openDatePicker('dpte')}
                            >
                                <ActionSchedule color={colors.link} />
                            </IconButton>
                        </div>
                    </div>

                    <section>
                        <small style={{ ...formElement.smallTitle, marginTop: 20 }}>Видео</small>
                        {this.state.video && <Preview
                            item={this.state.video}
                            mediaId={this.state.videoFile}
                            removePreview={() => {
                                this.setState({
                                    video: '',
                                    videoFile: '',
                                });
                            }}
                        />
                        }
                        <div>
                            <PopupGallery
                                open={this.state.openGallery}
                                type={this.state.galleryType}
                                closeDialogHandle={() => (this.setState({ openGallery: false }))}
                                insertMediaFile={item => this.insertMedia(item)}
                            />
                            <Icon icon="plus" />
                            <IconButton
                                containerElement="label"
                                style={buttonStyle.icon_space}
                                className="btn__hover_empty"
                                onClick={() => (this.setState({
                                    galleryType: ['video'],
                                    openGallery: true,
                                }))}
                            >
                                <Icon icon="video" />
                            </IconButton>
                        </div>

                        <Divider style={formElement.divider} />
                    </section>
                </Paper>
                <div style={styles.sidebar.default}>
					<Toggle
						style={{ margin: '10px 0' }}
						toggled={this.state.surdo}
						label="Сурдоперевод"
						onToggle={(e, v) =>
							this.setState({ surdo: v })}
					/>
					<Toggle
						style={{ margin: '10px 0' }}
						toggled={this.state.liveShow}
						label="LIVE"
						onToggle={(e, v) =>
							this.setState({ liveShow: v })}
					/>

					<Divider style={{ marginBottom: 10 }} />

                    <SelectField
                        style={styles.sidebar.selectField}
                        hintText="Программа"
                        floatingLabelText="Программа"
                        fullWidth={false}
                        value={this.state.show}
                        floatingLabelStyle={formElement.label}
                        onChange={(e, k, p) => this.setState({ show: p })}
                        dropDownMenuProps={{
                            iconButton: <Icon icon="triangle" />,
                            iconStyle: { marginTop: 4, marginRight: -21 },
                            style: { width: 273 },
                        }}
                    >
                        {
                            this.state.suggestions.length && this.state.suggestions.map(s => (
                                <MenuItem key={s.id} value={s.id} primaryText={s.title} />
                            ))
                        }
                    </SelectField>
                    <TopicSelector
                        style={{
                            flexGrow: 1,
                        }}
                        viewer={this.props.viewer}
                        value={this.state.topics}
                        onChange={v => this.setState({ topics: v })}
                    />

                    <div className="button__bottom">
                        <SelectField
                            floatingLabelText="Статус передачи"
                            value={this.state.state}
                            onChange={(e, i, state) => this.setState({ state })}
                        >
                            <MenuItem value="available" primaryText="Опубликована" />
                            <MenuItem value="hidden" primaryText="Скрыта" />
                        </SelectField>
                        <DefaultButton label="Сохранить" onClick={this.save} />
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(createFragmentContainer(
    EpgItem,
    graphql`
        fragment EpgItem_epgitem on TVShowEpisode  {
            id
            title
            subtitle
            description
            shortDescription
            startDate
            endDate
            liveShow
            surdo
            show {
                id
            }
            videoFile {
                id
                filename
            }
            preview {
                id
                filename
            }
            topics {
                id
                name
            }
            state
        },
    `,
));

export { checkDate };



// WEBPACK FOOTER //
// src/components/epg/EpgItem.js